









import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { CanopyStore, LayoutStore } from "@/mixins/store";
import UnifiedLayout from "@/components/designer/sidebar/canopy/layouts/UnifiedLayout.vue";
import { StockMixin } from "@/mixins/stock";

@Component({
  components: {
    UnifiedLayout
  }
})
export default class CanopySidebar extends mixins(
  CanopyStore,
  LayoutStore,
  StockMixin
) {
  @Prop() hasVent!: boolean;
  @Prop() hasValance!: boolean;
}
